import { QwiSearchSettings } from '@components/settings/tools/qwi-search'

export const QwiSearchPage = () => {
  return <QwiSearchSettings />
}
